module.exports = __webpack_public_path__ + "static/ChatbotRingSavvy_Img2-0513840cf23971af83debedfe2fc0005.png";